export default __webpack_public_path__ + "static/media/plant.60c83df4.svg";